var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', [_c('page-section', {
    staticClass: "page-section--first page-section--last"
  }, [_c('template', {
    slot: "tit"
  }, [_vm._v(_vm._s(_vm.groupText))]), _vm.items.length ? [_c('v-row', _vm._l(_vm.items, function (item) {
    var _item$thumb;
    return _c('v-col', {
      key: item._id,
      attrs: {
        "cols": "12"
      }
    }, [_c('v-card', {
      attrs: {
        "flat": "",
        "rounded": "",
        "to": `${_vm.$route.path}/${item._id}`
      }
    }, [_c('v-img', {
      attrs: {
        "cover": "",
        "src": item === null || item === void 0 ? void 0 : (_item$thumb = item.thumb) === null || _item$thumb === void 0 ? void 0 : _item$thumb.url,
        "aspect-ratio": _vm.$vuetify.breakpoint.lgAndUp ? 1200 / 240 : 300 / 100
      }
    })], 1)], 1);
  }), 1), _c('div', {
    staticClass: "pagination-wrap"
  }, [_c('v-pagination', {
    staticClass: "mt-2",
    attrs: {
      "value": _vm.page,
      "length": _vm.pageCount,
      "total-visible": 11,
      "color": "primary"
    },
    on: {
      "input": function (page) {
        return _vm.$router.push({
          query: Object.assign({}, _vm.$route.query, {
            page
          })
        });
      }
    }
  })], 1)] : !_vm.loading ? [_c('div', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "mb-18px mb-md-24px"
  }, [_c('v-icon', {
    attrs: {
      "size": "60px",
      "color": "primary"
    }
  }, [_vm._v("mdi-calendar-star")])], 1), _c('div', {
    staticClass: "tit tit--sm"
  }, [_vm._v("등록된 " + _vm._s(_vm.groupText) + " 항목이 없습니다.")]), _c('div', {
    staticClass: "txt txt--sm mt-8px"
  }, [_vm._v("상품 목록을 확인해주세요.")]), _c('div', {
    staticClass: "btn-wrap btn-wrap--lg"
  }, [_c('v-row', {
    staticClass: "row--sm",
    attrs: {
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "6",
      "sm": "auto"
    }
  }, [_c('v-btn', {
    staticClass: "v-size--xx-large w-100 min-w-sm-200px",
    attrs: {
      "color": "primary",
      "to": "/shop"
    }
  }, [_vm._v("쇼핑 계속하기")])], 1)], 1)], 1)])] : _vm._e()], 2)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }